import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../../../Utilities/Api";

class serverAphQueueApi {

    static GetUserAphQueueItems() {
        return sendRequest(
            requestOptions(config.URL + `aph/queue`,
                requestTypes.GET,
            ),
        );
    }

    static deleteAphQueueItem(aphQueueItemId: string) {
        return sendRequest(
            requestOptions(config.URL + `aph/queue/${aphQueueItemId}`,
                requestTypes.DELETE,
                null,
                apiConstants.successMessage.queue.DELETE,
            ),
        );
    }

    static assignStudentToAphQueueItems(studentQueueViewModel: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `aph/queue/assign-student`,
                requestTypes.PUT,
                JSON.stringify(studentQueueViewModel),
                apiConstants.successMessage.queue.UPDATE,
            ),
        );
    }

    static getStudents(studentSearchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(studentSearchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(`${config.URL}students/patrons?${queryParameters}`,
                requestTypes.GET,
            )
        );
    }


}

export const aphQueueApi = config.environment.MODE === config.modes.SERVER ? serverAphQueueApi : serverAphQueueApi;
